export enum Addon {
	APP = "app",
	CONTACT_DATABASE = "contactDatabase",
	CMS = "cms",
	PREFERENCES = "preferences",
}
